import { IContactListItem } from 'interfaces/redux/IContactList';
import { IPatient } from 'interfaces/redux/IPatient';

const isIContactListItem = (contact: IContactListItem | IPatient) => {
  return (contact as IContactListItem).relationship !== undefined;
};

export { isIContactListItem };
